import React, { useMemo } from 'react';
import { titlePaths } from '@warehouse/title/core';
import { TitleTextInputField } from '@warehouse/title/ui';

export function CopyrightLineField({ localizedInfoUuid }: { localizedInfoUuid: string }) {
	const path = useMemo(() => titlePaths.copyrightLine(localizedInfoUuid), [localizedInfoUuid]);

	return <TitleTextInputField label="Copyright Line" path={path} />;
}
